export interface VCardData {
  firstname: string;
  lastname: string;
  org: string;
  title: string;
  phone: string;
  email: string;
  website: string;
  address?: string;
}

/**
 * Tạo nội dung vCard 3.0 (tương thích iOS Contacts, Android Contacts, Outlook).
 * Dùng \r\n theo đúng chuẩn RFC 6350 để tránh lỗi parse trên một số máy Android/Outlook.
 */
export function buildVCard(data: VCardData): string {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${data.firstname}`,
    `LN:${data.lastname}`,
    `ORG:${data.org}`,
    `TITLE:${data.title}`,
    `TEL;TYPE=CELL:${data.phone}`,
    `EMAIL:${data.email}`,
    `URL:${data.website}`,
  ];

  if (data.address) {
    lines.push(`ADR;TYPE=WORK:;;${data.address};;;;`);
  }

  lines.push("END:VCARD");

  return lines.join("\r\n");
}

/**
 * Tạo file contact.vcf và kích hoạt tải xuống trên trình duyệt.
 * Hoạt động trên iOS Safari, Android Chrome và desktop.
 */
export function downloadVCard(data: VCardData, filename = "contact.vcf"): void {
  const vcard = buildVCard(data);
  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
